module.exports = __webpack_public_path__ + "img/nekmies.df6b0b62.jpg";